import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { connect } from 'react-redux';
import { GoogleMap, Circle } from "@react-google-maps/api";
import { COMMON_COLOR } from '../../../constants/index';

// Google Maps Loader Helper
import { loadGoogleMaps, isGoogleMapsLoaded } from '../../../helpers/googleMapsLoader';

import messages from '../../../locale/messages';

// Map Theme
import { mapStyles } from '../../../utils/mapTheme';

// UI Components
import ModernMapContainer from '../../UI/ModernMapContainer';

import s from './LocationMap.css';
import cs from '../../../components/commonStyle.css';

const containerStyle = {
  width: '100%',
  height: '100%'
};
class LocationMap extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    formatMessage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      center: {},
      markers: null,
      googleMapsApiLoaded: false,
    }
  }

  async componentDidMount() {
    // Load Google Maps using centralized helper
    if (!isGoogleMapsLoaded()) {
      await loadGoogleMaps();
    }
    this.setState({ googleMapsApiLoaded: true });
  }

  UNSAFE_componentWillMount() {
    const { data } = this.props;
    let lat = data.lat;
    let lng = data.lng;
    this.setState({
      center: {
        lat: Number(lat),
        lng: Number(lng),
      },
      smallDevice: false
    });
  }

  handleOnLoad = (map) => {
    const { center } = this.state;
    const markers = [{
      position: new google.maps.LatLng(center.lat, center.lng)
    }];
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ position }) => bounds.extend(position));
    map.fitBounds(bounds);
  };

  render() {
    const { center, googleMapsApiLoaded } = this.state;
    const { data } = this.props;
    let displayName = data.user.profile.displayName;

    return (
      <>
        <div className={'viewListingMap'}>
          <h4 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.neighborhood} /></h4>
          <h5 className={cx(cs.commonContentText, cs.paddingBottom2, cs.fontWeightNormal)}>
            {displayName}{' '}<FormattedMessage {...messages.propertyLocated} />{' '}{data.city}, {data.state}, {data.country}
          </h5>
          <ModernMapContainer height="452px" borderRadius="16px" mobileRadius="12px">
            {
              googleMapsApiLoaded ?
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  defaultZoom={10}
                  center={center}
                  onLoad={this.handleOnLoad}
                  clickableIcons={false}
                  options={{
                    backgroundColor: '',
                    scrollwheel: false,
                    maxZoom: 16,
                    minZoom: 11,
                    streetViewControl: false,
                    zoomControlOptions: {
                      position: window.google?.maps?.ControlPosition?.RIGHT_TOP || 3
                    },
                    mapTypeControl: false,
                    styles: mapStyles
                  }}
                >
                  <Circle
                    center={center}
                    radius={200}
                    options={{
                      fillColor: COMMON_COLOR,
                      strokeColor: COMMON_COLOR,
                    }}
                  />
                </GoogleMap>
                :
                <></>
            }
          </ModernMapContainer>
          <p className={cx(cs.commonContentText, cs.paddingTop2)}>
            <span className={cs.fontWeightBold}><FormattedMessage {...messages.noteLabel} /></span>:{' '}<FormattedMessage {...messages.neighborhoodInfo} />
          </p>
        </div>
        <hr className={cs.listingHorizoltalLine} />
      </>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(LocationMap)));